import { useEffect } from "react";

export function tg() {
  return window.Telegram?.WebApp;
}

type MainButtonOptions = {
  text: string;
  onClick: () => void;
  enabled?: boolean;
  loading?: boolean;
};

/** Показывает MainButton с заданным текстом и обработчиком. На размонтировании — скрывает. */
export function useMainButton(opts: MainButtonOptions | null) {
  useEffect(() => {
    const wa = tg();
    const mb = wa?.MainButton;
    if (!mb) return;

    if (opts === null) {
      mb.hide();
      return;
    }

    mb.setText(opts.text);
    if (opts.enabled === false) {
      mb.disable();
    } else {
      mb.enable();
    }
    if (opts.loading) {
      mb.showProgress(false);
    } else {
      mb.hideProgress();
    }
    mb.show();

    const cb = () => opts.onClick();
    mb.onClick(cb);
    return () => {
      mb.offClick(cb);
      mb.hide();
    };
    // ВАЖНО: текст/enabled/loading включаем в зависимости, чтобы Telegram-кнопка
    // обновлялась при изменении состояния.
  }, [opts?.text, opts?.enabled, opts?.loading, opts?.onClick]);
}

/** Показывает BackButton и вешает обработчик. На размонтировании — скрывает. */
export function useBackButton(onClick: (() => void) | null) {
  useEffect(() => {
    const wa = tg();
    const bb = wa?.BackButton;
    if (!bb) return;

    if (!onClick) {
      bb.hide();
      return;
    }

    bb.show();
    bb.onClick(onClick);
    return () => {
      bb.offClick(onClick);
      bb.hide();
    };
  }, [onClick]);
}

type HapticFn = ((type: "success" | "error" | "warning") => void) & {
  selectionChanged: () => void;
  impact: (style: "light" | "medium" | "heavy" | "rigid" | "soft") => void;
};

/**
 * Нативный confirm Telegram. На старых клиентах (где `showConfirm` нет) — fallback на window.confirm.
 * Возвращает Promise<boolean>: true если юзер подтвердил, false если отменил.
 */
export function showConfirm(message: string): Promise<boolean> {
  const wa = tg();
  if (wa?.showConfirm) {
    return new Promise((resolve) => {
      wa.showConfirm!(message, (ok) => resolve(ok));
    });
  }
  return Promise.resolve(window.confirm(message));
}

export const haptic: HapticFn = Object.assign(
  (type: "success" | "error" | "warning") => {
    tg()?.HapticFeedback?.notificationOccurred(type);
  },
  {
    selectionChanged: () => {
      tg()?.HapticFeedback?.selectionChanged();
    },
    impact: (style: "light" | "medium" | "heavy" | "rigid" | "soft") => {
      tg()?.HapticFeedback?.impactOccurred(style);
    },
  },
);
